import React from "react";
import { RANGE_OPTIONS } from "../../lib/useSyncedRange";

/**
 * Compact pill-style range toggle used by both `GA4Panel` and `GscPanel`.
 * Wire it up to the shared `useSyncedRange` hook so the two panels move
 * together across tabs.
 */
export default function RangeToggle({ range, onChange, disabled, testid = "range-toggle" }) {
  return (
    <div
      className="inline-flex items-center gap-0.5 rounded-xl border border-[#e2e8f0] bg-[#f7fafc] p-0.5"
      data-testid={testid}
      role="tablist"
      aria-label="Overview range"
    >
      {RANGE_OPTIONS.map((opt) => {
        const active = range === opt.key;
        return (
          <button
            key={opt.key}
            type="button"
            role="tab"
            aria-selected={active}
            data-testid={`${testid}-${opt.key}`}
            onClick={() => onChange(opt.key)}
            disabled={disabled}
            className={`px-3 py-1.5 rounded-lg text-[11px] font-bold uppercase tracking-widest transition-all disabled:opacity-60 ${
              active
                ? "bg-white text-[#234e52] shadow-[0_2px_4px_-1px_rgba(45,55,72,0.08)] border border-[#e2e8f0]"
                : "text-[#718096] hover:text-[#234e52]"
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
